import { queryConfig } from './queryConfig';

export interface Program {
  uid: string;
  name: string;
  merchant_name: string;
  starts_at: string;
  ends_at: string;
  active: boolean;
}

const query = queryConfig({});

export const useGetPrograms = (params?: { page?: number; limit?: number; q?: string }) =>
  query<{ page: number; limit: number; total: number; programs: Program[] }>({
    url: '/v1/ops/programs',
    cacheKey: 'programs',
    params,
  });
